import React, { useContext, useState, useEffect } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import { RiCloseCircleFill } from "react-icons/ri";
import AllDocumentsTable from "./AllDocumentsTable";
import { AuthContext } from "../../../context/Auth/AuthContext";
import getAllDocumentList from "../../../api/getAllDocumentList";
import UploadDocumentsPopup from "./UploadDocumentsPopup";
import Loading from "../../material-ui/Loading";
import BasicDatePicker from "../../material-ui/DatePicker";

// Category, Name, CaseId, Modified By (auto-set), Modified Date (auto-set), Description/Comment

const AllDocumentsList = ({
  caseNo,
  caseID,
  oppId,
  caseDocumentsType,
  selectedCaseDocumentsType,
  changeSelectedCaseDocumentsType,
  preferredLanguage,
}) => {
  const [loading, setLoading] = useState(true);
  const [documentDeleted, setDocumentDeleted] = useState(0);
  const [documentViewer, setDocumentViewer] = useState(false);
  const [pdfLink, setPdfLink] = useState("");
  const [pdfViewerTitle, setPdfViewerTitle] = useState("");

  const [category, setCategory] = useState("");
  const [name, setName] = useState("");
  const [docCaseID, setDocCaseID] = useState("");
  const [modifiedBy, setModifiedBy] = useState("");
  const [modifiedDate, setModifiedDate] = useState(null);
  const [comment, setComment] = useState("");

  const [documentResponse, setDocumentResponse] = useState([]);

  const { token } = useContext(AuthContext);

  const setDocumentDeletedToTrue = () => {
    setDocumentDeleted((count) => count + 1);
  };

  const changeDocumentViewerState = (link, name) => {
    console.log(link);
    setPdfLink(link);
    setPdfViewerTitle(name);
    setDocumentViewer(!documentViewer);
  };

  const documentResponseFunc = async () => {
    if (!documentDeleted) {
      setLoading(true);
    }
    const data = await getAllDocumentList({ token, caseNo, caseID });
    setDocumentResponse(data?.data?.data);
    if (!documentDeleted) {
      setLoading(false);
    }
  };

  useEffect(() => {
    documentResponseFunc();
  }, [documentDeleted]);

  return (
    <>
      {!documentViewer ? (
        <>
          <div className="all-doc-table-header">
            <UploadDocumentsPopup
              caseNo={caseNo}
              caseID={caseID}
              setDocumentDeletedToTrue={setDocumentDeletedToTrue}
            />
            <FormControl className="case-doc-select-ui">
              <InputLabel className="case-doc-select-label" id="select-label">
                Category
              </InputLabel>
              <Select
                name="addDocCategories"
                sx={{ margin: "10px 0px", maxWidth: "20" }}
                labelId="select-label"
                variant="outlined"
                id="simple-select"
                value={selectedCaseDocumentsType}
                onChange={changeSelectedCaseDocumentsType}
                label="Category"
              >
                {caseDocumentsType.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          {!loading ? (
            documentResponse.length !== 0 ? (
              <div className="document__table">
                <AllDocumentsTable
                  setDocumentDeletedToTrue={setDocumentDeletedToTrue}
                  oppId={oppId}
                  documentResponse={documentResponse}
                  preferredLanguage={preferredLanguage}
                  changeDocumentViewerState={changeDocumentViewerState}
                />
              </div>
            ) : (
              <h5 className="no-doc-data">No Data Available</h5>
            )
          ) : (
            <Loading />
          )}
        </>
      ) : (
        <div className="all-document-pdf-viewer">
          <div className="all-document-pdf-viewer-header">
            <div className="all-document-pdf-viewer-title">
              {pdfViewerTitle}
            </div>
            <div
              className="all-document-pdf-viewer-icon"
              onClick={() => setDocumentViewer(false)}
            >
              <RiCloseCircleFill />
            </div>
          </div>
          <div className="document-viewer-with-from">
            <div className="iframe-wrapper">
              <iframe
                title={pdfViewerTitle}
                src={pdfLink}
                width="100%"
                height="590"
              ></iframe>
            </div>
            <div className="document-viewer-form">
              <TextField
                name="name"
                label="Name"
                type="text"
                autoComplete="off"
                value={name}
                onChange={(e) => setName(e.target.value)}
                variant="outlined"
                fullWidth
              />
              <TextField
                name="category"
                label="Category"
                type="text"
                autoComplete="off"
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                variant="outlined"
                style={{ marginTop: "10px" }}
                fullWidth
              />
              <TextField
                name="caseId"
                label="Case ID"
                type="text"
                autoComplete="off"
                value={docCaseID}
                onChange={(e) => setDocCaseID(e.target.value)}
                variant="outlined"
                style={{ marginTop: "10px" }}
                fullWidth
              />
              <TextField
                name="modifiedBy"
                label="Modified By"
                type="text"
                autoComplete="off"
                value={modifiedBy}
                onChange={(e) => setModifiedBy(e.target.value)}
                variant="outlined"
                style={{ marginTop: "10px" }}
                fullWidth
              />

              <TextField
                name="comment"
                label="Comment"
                multiline
                maxRows={3}
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                variant="outlined"
                style={{ marginTop: "10px" }}
                fullWidth
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AllDocumentsList;
